<div class="bg-m1 flex h-full items-center justify-center">
  <div class="flex flex-col items-center">
    <div>
      <m-document-ring></m-document-ring>
    </div>

    <div
      data-cy="projectDeletedTitle"
      class="text-s2 mt-5 select-none text-2xl font-semibold"
      >{{ pageTitle }}</div
    >
  </div>
</div>
